export function DataCell({ label, value }: { label: string; value: string }) {
	return (
		<div className="px-4 py-3">
			<div className="border-primary-200 bg-primary-50 text-primary-800" />
			<p className="mb-0.5 text-xs text-gray-500">{label}</p>
			<p className="text-sm font-medium text-gray-900">{value}</p>
		</div>
	);
}
